import { Injectable, inject, signal } from '@angular/core';
import { AuthDataAccess } from '../auth/data-access/auth.data-access';
import type { Office } from '../core/infraestructure/interfaces/office';
import { StorageDataAccess } from './storage.data-access';

export const OFFICE_KEY = 'office';

@Injectable({
  providedIn: 'root',
})
export class OfficeDataAccess {
  private storage = inject<StorageDataAccess<number>>(StorageDataAccess);

  offices = signal<Office[]>([]);

  selectedOffice = signal<number | undefined>(
    this.storage.getItem(OFFICE_KEY) ?? undefined,
  );

  authDataAccess = inject(AuthDataAccess);

  setSelectedOffice(officeId: number | undefined): void {
    if (officeId === undefined) {
      this.storage.removeItem(OFFICE_KEY);
      this.selectedOffice.set(undefined);
      return;
    }
    this.storage.setItem(OFFICE_KEY, officeId);
    this.selectedOffice.set(officeId);
  }

  getOffices() {
    const data = this.authDataAccess.getUserInfo();
    if (!data) return;

    const offices = data.sucursales.map((sucursal) => ({
      id: sucursal.IdSucursal,
      title: sucursal.Nombre,
    }));

    this.offices.set(offices);
  }
}
